import React, { memo } from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Input from '@active/react-ui/Input'
import IntlPhoneInput from '@active/react-ui/IntlPhoneInput'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import Button from '@active/react-ui/Button'
import LinkButton from '@active/react-ui/LinkButton'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import noop from 'lodash/fp/noop'
import {
  bool, func, string, number, oneOfType,
} from 'prop-types'
import I18nMessage from '../../../I18nMessage'
import './VerifyCodeByPhone.scss'

function VerifyCodeByPhone({
  onSendCode,
  countDownNumber,
  showSentCodeWording,
  showMethodChangeLink,
  onChangeMethod,
  proxyForm,
  i18n,
  locale = 'en_US',
},
) {
  const buttonText = 'passport.common.btn.send'
  return (
    <Form className="verify-code-by-phone-form">
      <Grid fluid rowGap={0} colGap={0}>
        <GridItem span={12} spanSm={8}>
          <FormGroup name="phoneNumber" className="relative" required withoutLayout>
            <FormLabel>
              <I18nMessage id="passport.phoneAuthentication.modal.input.label.mobilePhoneNumber" />
            </FormLabel>
            <FormField
              defaultLocale={locale}
              placeholder={i18n('passport.verification.modal.input.phone.placeholder')}
              as={IntlPhoneInput}
              autoComplete="tel"
              requiredError={i18n('passport.verification.modal.input.phone.required.error')}
            />
            <Responsive eqAbove="sm">
              <Button type="primary" className="sent-btn" onClick={onSendCode} disabled={!!countDownNumber}>{countDownNumber ? `${countDownNumber}s` : <I18nMessage id={buttonText} />}</Button>
            </Responsive>
          </FormGroup>
        </GridItem>
        { showSentCodeWording && (
          <GridItem className="sent-code-wording" rowGap={0} span={12} spanSm={8}>
            <i className="ic-check-r" />
            <I18nMessage id="passport.security.setting.sent.code.tips" />
          </GridItem>
        ) }
        {
          showMethodChangeLink && (
            <Responsive eqAbove="sm">
              <GridItem span={12} className="mg-t-4">
                <LinkButton onClick={() => onChangeMethod('EMAIL')}>
                  <I18nMessage id="passport.phoneAuthentication.modal.change.method.link" />
                </LinkButton>
              </GridItem>
            </Responsive>
          )
        }
        <Responsive eqAbove="sm" not>
          <GridItem span={12} className={showMethodChangeLink ? 'flex-space-between links' : 'links'}>
            {
              showMethodChangeLink && (
                <LinkButton onClick={() => onChangeMethod('EMAIL')}>
                  <I18nMessage id="passport.phoneAuthentication.modal.change.method.link" />
                </LinkButton>
              )
            }
            <LinkButton onClick={onSendCode} disabled={!!countDownNumber} className={showMethodChangeLink && 'mg-r-8'}>
              <I18nMessage id={buttonText} />
              {countDownNumber ? `(${countDownNumber}s)` : '' }
            </LinkButton>
          </GridItem>
        </Responsive>
        <GridItem span={12} spanSm={8} className="mg-t-6">
          <FormGroup name="code" required withoutLayout>
            <FormLabel>
              <I18nMessage id="passport.verification.modal.input.placeholder" />
            </FormLabel>
            <FormField
              placeholder={i18n('passport.verification.modal.input.code.placeholder')}
              as={Input}
              autoComplete="one-time-code"
              requiredError={i18n('passport.verification.modal.input.code.required.error')}
            />
          </FormGroup>
        </GridItem>
      </Grid>
      <FormConsumer>
        {
                ({
                  form,
                }) => {
                  proxyForm(form)
                }
            }
      </FormConsumer>
    </Form>
  )
}

VerifyCodeByPhone.propTypes = {
  proxyForm: func.isRequired,
  countDownNumber: oneOfType([string, number]),
  onSendCode: func.isRequired,
  showMethodChangeLink: bool,
  onChangeMethod: func,
  showSentCodeWording: bool,
  i18n: func.isRequired,
  locale: string,
}
VerifyCodeByPhone.defaultProps = {
  countDownNumber: 0,
  showMethodChangeLink: false,
  onChangeMethod: noop,
  showSentCodeWording: false,
  locale: 'en_US',
}
export default memo(withI18n(VerifyCodeByPhone))
